// extracted by mini-css-extract-plugin
module.exports = {"footerBg":"a-z","footerTopLinks":"b-z","footerFeedback":"c-z","footerSocial":"d-z","footerLegalLinks":"e-z","footerIconCards":"f-z","footerBotCopy":"g-z","screenReadersOnly":"h-z"};